import { AllowedValuesDTO, UnitDescription } from "api";

/**
 * Finds utility type information by name
 * @param allowedValues - Allowed values containing utility types
 * @param utilityTypeName - Name of the utility type to find
 * @returns Utility type info or undefined
 */
export const findUtilityTypeInfo = (
    allowedValues?: AllowedValuesDTO,
    utilityTypeName?: string
): { id: number; name: string; unitDescription?: UnitDescription[] } | undefined => {
    if (!allowedValues?.utilityTypes || !utilityTypeName) {
        return undefined;
    }
    return allowedValues.utilityTypes.find(
        (ut: any) => ut.name.toLowerCase() === utilityTypeName.toLowerCase()
    );
};

/**
 * Gets available units for a utility type
 * @param allowedValues - Allowed values containing utility types
 * @param utilityTypeName - Name of the utility type
 * @returns Array of unit descriptions or empty array
 */
export const getAvailableUnitsForUtilityType = (
    allowedValues?: AllowedValuesDTO,
    utilityTypeName?: string
): UnitDescription[] => {
    const utilityTypeInfo = findUtilityTypeInfo(allowedValues, utilityTypeName);
    return utilityTypeInfo?.unitDescription || [];
};

